"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SortsService", {
    enumerable: true,
    get: function() {
        return SortsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _Noco = /*#__PURE__*/ _interop_require_default(require("src/Noco"));
const _viewwebhookmanager = require("~/utils/view-webhook-manager");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let SortsService = class SortsService {
    async sortGet(context, param) {
        return _models.Sort.get(context, param.sortId);
    }
    async sortDelete(context, param, ncMeta = _Noco.default.ncMeta) {
        var _param_viewWebhookManager;
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const sort = await _models.Sort.get(context, param.sortId, ncMeta);
        if (!sort) {
            _catchError.NcError.badRequest('Sort not found');
        }
        const column = await _models.Column.get(context, {
            colId: sort.fk_column_id
        }, ncMeta);
        const view = await _models.View.get(context, sort.fk_view_id, ncMeta);
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        await _models.Sort.delete(context, param.sortId, ncMeta);
        this.appHooksService.emit(_nocodbsdk.AppEvents.SORT_DELETE, {
            sort,
            req: param.req,
            view,
            column,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'sort_delete',
                payload: sort
            }
        }, context.socket_id);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(view.id)).emit();
        }
        return true;
    }
    async sortUpdate(context, param, ncMeta = _Noco.default.ncMeta) {
        var _param_viewWebhookManager;
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/SortReq', param.sort);
        const sort = await _models.Sort.get(context, param.sortId, ncMeta);
        if (!sort) {
            _catchError.NcError.badRequest('Sort not found');
        }
        const column = await _models.Column.get(context, {
            colId: sort.fk_column_id
        }, ncMeta);
        const view = await _models.View.get(context, sort.fk_view_id, ncMeta);
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        const res = await _models.Sort.update(context, param.sortId, param.sort, ncMeta);
        this.appHooksService.emit(_nocodbsdk.AppEvents.SORT_UPDATE, {
            sort: _extends({}, sort, param.sort),
            oldSort: sort,
            column,
            view,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'sort_update',
                payload: _extends({}, sort, param.sort)
            }
        }, context.socket_id);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(view.id)).emit();
        }
        return res;
    }
    async sortCreate(context, param, ncMeta) {
        var _param_viewWebhookManager;
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/SortReq', param.sort);
        const view = await _models.View.get(context, param.viewId, ncMeta);
        if (!view) {
            _catchError.NcError.badRequest('View not found');
        }
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        const sort = await _models.Sort.insert(context, _extends({}, param.sort, {
            fk_view_id: param.viewId
        }), ncMeta);
        const column = await _models.Column.get(context, {
            colId: sort.fk_column_id
        }, ncMeta);
        this.appHooksService.emit(_nocodbsdk.AppEvents.SORT_CREATE, {
            sort,
            view,
            column,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'sort_create',
                payload: sort
            }
        }, context.socket_id);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(view.id)).emit();
        }
        return sort;
    }
    async sortList(context, param) {
        return _models.Sort.list(context, {
            viewId: param.viewId
        });
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
SortsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], SortsService);
